import React, { memo, useState } from "react";
import Modal from "./Modal";
import "./styles/scss/SelectTime.scss";

function App(props) {
	const { isShow, onClose, useAble = [], playType } = props;
	const [time, setTime] = useState(0);

	return (
		<Modal
			className="popup-select-time"
			visible={isShow}
			onClose={onClose}
			style={{ paddingLeft: 37 }}
		>
			<div className="popup-content">
				<span>选择本次游戏时长</span>
				<div className="content">
					<div>
						<div className="head" style={{ fontWeight: 900 }}>
							为保障您的身心健康，平台建议本次游戏时长
						</div>
						<div className="body">提示:超出时长可重新启动游戏进行游玩</div>
						<div className="radio">
							{(playType === "netbarPlay"
								? useAble.filter((ele) => ele.includes("8"))
								: useAble
							).map((ele, index) => {
								return (
									<div
										key={index}
										onClick={() => {
											setTime(index);
										}}
									>
										<button
											type="button"
											className={time === index ? "active" : ""}
										></button>
										{ele}
									</div>
								);
							})}
						</div>
					</div>
				</div>
				<div className="btn-group">
					<button
						type="button"
						onClick={() => {
							onClose();
						}}
					>
						取消
					</button>

					<button
						type="button"
						onClick={() => {
							props.onOk?.(time);
						}}
					>
						确定
					</button>
				</div>
			</div>
		</Modal>
	);
}

export default memo(App);
